module.exports = __webpack_public_path__ + "static/media/sf-test-7.a2db12d8.mp3";